import { useState, useEffect } from "react";

const MOBILE_WIDTH_THRESHOLD = 767;

const getWindowDimensions = () => {
  const { innerWidth: windowWidth, innerHeight: windowHeight } = window;
  return {
    windowWidth,
    windowHeight,
  };
};

/**
 * Use to gather the dimenions of the current window for the user.
 * Can be utilized to branch logic based off of mobile view or other
 * specific dimensions.
 * @returns Window Dimensions and a boolean for isMobileView
 */
const useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return {
    ...windowDimensions,
    isMobileView: windowDimensions.windowWidth <= MOBILE_WIDTH_THRESHOLD,
  };
};

export default useWindowDimensions;
